const reimburse = {
  plCode: 'Vui lòng nhập mã',
  plName: 'Vui lòng nhập tên',
  plDesc: 'Vui lòng nhập mô tả',
  disableTip: 'Bạn có chắc chắn muốn vô hiệu hóa danh mục này không',
  disableConfirm: 'Xác nhận vô hiệu hóa',
  disableConfirmContent: 'Xác nhận vô hiệu hóa danh mục',
  disableSuccess: 'Vô hiệu hóa thành công',
  disableSuccessDesc: 'đã bị vô hiệu hóa',
  disableFailed: 'Vô hiệu hóa thất bại',
  disableFailedHasSubs: 'Danh mục này có danh mục con và không thể vô hiệu hóa',
  addSuccessDesc: 'đã thêm thành công',
  updateSuccessDesc: 'đã cập nhật',
  addFailed: 'Thêm thất bại',
  codeDuplicate: 'Mã đã tồn tại',
  applicationTypeLabel: 'Loại đơn',
  approveTypeLabel: 'Phương thức phê duyệt',
  stepCount: 'Bước',
  reimbursement: 'Đơn hoàn tiền',
  dailySupplies: 'Đồ dùng hàng ngày/Vật tư',
  materialOverIssue: 'Đơn xin lĩnh vật tư vượt mức',
  addMaterialOverIssue: 'Thêm đơn xin lĩnh vật tư vượt mức',
  materialOverIssueList: 'Danh sách đơn xin lĩnh vật tư vượt mức',
  inOrder: 'Theo thứ tự',
  any: 'Bất kỳ bước nào được duyệt',
  last: 'Bước cuối cùng được duyệt',
  templateConfig: 'Cấu hình mẫu',
  approvalSteps: 'Các bước phê duyệt',
  step: 'Bước',
  addStep: 'Thêm bước',
  specificOrgAnyone: 'Bất kỳ ai trong tổ chức chỉ định',
  applicantOrgAnyone: 'Bất kỳ ai trong tổ chức người đăng ký',
  specificUsers: 'Người dùng cụ thể',
  plSelectOrg: 'Vui lòng nhập ID tổ chức',
  plOrgId: 'ID tổ chức',
  plSelectUsers: 'Vui lòng chọn người dùng',
  number: 'Số',
  title: 'Tiêu đề',
  status: 'Trạng thái',
  statusAll: 'Tất cả',
  statusDraft: 'Bản nháp',
  statusPending: 'Chờ phê duyệt',
  statusApproved: 'Đã phê duyệt',
  statusRejected: 'Đã từ chối',
  statusReturned: 'Đã trả về',
  applicationList: 'Danh sách đơn',
  addApplication: 'Thêm',
  plTitle: 'Vui lòng nhập tiêu đề',
  plContent: 'Vui lòng nhập nội dung',
  plPurpose: 'Vui lòng nhập mục đích',
  plRemark: 'Vui lòng nhập ghi chú',
  content: 'Nội dung',
  purpose: 'Mục đích',
  remark: 'Ghi chú',
  items: 'Mục',
  itemList: 'Danh sách mục đơn',
  count: 'Số lượng',
  selectProducts: 'Thêm theo mã vật tư',
  plSelectProducts: 'Vui lòng chọn vật tư',
  submit: 'Gửi',
  reSubmit: 'Gửi lại',
  submitSuccess: 'Gửi thành công',
  submitFailed: 'Gửi thất bại',
  amount: 'Số tiền',
  orderAmount: 'Số lượng cần lĩnh',
  productId: 'ID vật tư',
  requirementItemId: 'Hạng mục yêu cầu',
  overCount: 'Số lượng lĩnh vượt',
  reasonType: 'Lý do lĩnh vượt',
  reasonMistake: 'Sai sót',
  reasonWaste: 'Lãng phí',
  reasonOther: 'Khác',
  reason: 'Mô tả chi tiết',
  picked: 'Đã tạo phiếu xuất kho',
  pickedYes: 'Có',
  pickedNo: 'Không',
  expenseDate: 'Ngày chi phí',
  invoiceCount: 'Số lượng hóa đơn',
  plAmount: 'Vui lòng nhập số tiền',
  plInvoiceCount: 'Vui lòng nhập số lượng hóa đơn',
  plExpenseDate: 'Vui lòng chọn ngày chi phí',
  atLeastOne: 'Cần ít nhất một mục',
  submitConfirm: 'Bạn có chắc chắn muốn gửi đơn hoàn tiền không?',
  submitOverIssueConfirm: 'Bạn có chắc chắn muốn gửi đơn xin lĩnh vật tư vượt mức không?',
  addDailyItem: 'Thêm không có mã vật tư',
  approver: 'Người phê duyệt',
  actualApprover: 'Người phê duyệt thực tế',
  approveTime: 'Thời gian phê duyệt',
  approveOrg: 'Tổ chức phê duyệt',
  applicant: 'Người đăng ký',
  submitTime: 'Thời gian gửi',
  completeTime: 'Thời gian hoàn thành',
  stepNo: 'Bước',
  pass: 'Phê duyệt',
  reject: 'Từ chối',
  return: 'Trả về',
  passSuccess: 'Đã phê duyệt',
  rejectSuccess: 'Đã từ chối',
  returnSuccess: 'Đã trả về',
  passFailed: 'Phê duyệt thất bại',
  rejectFailed: 'Từ chối thất bại',
  returnFailed: 'Trả về thất bại',
  confirmPass: 'Bạn có chắc chắn phê duyệt?',
  confirmReject: 'Bạn có chắc chắn từ chối?',
  confirmReturn: 'Bạn có chắc chắn trả về?',
  approveRemark: 'Ghi chú phê duyệt',
  plApproveRemark: 'Vui lòng nhập ghi chú phê duyệt',
  timeout: 'Thời gian chờ',
  approvalTimeLimit: 'Thời hạn phê duyệt',
  enableConfirm: 'Xác nhận kích hoạt',
  disableCascadeTip: 'Vô hiệu hóa danh mục này sẽ cũng vô hiệu hóa tất cả danh mục con',
  enableCascadeTip: 'Kích hoạt danh mục này sẽ cũng kích hoạt tất cả danh mục con',
};

export default reimburse;
